export function formatDate(datetime: string): string {
  const date = new Date(datetime);
  return date.toLocaleDateString("fr-FR");
}
